"use client";

import { useRef } from "react";
import { ChevronDown } from "lucide-react";

/**
 * The phone-width jump menu: a native <details> (works before hydration)
 * that folds itself away once a link inside it is followed, so the menu
 * isn't left open above the section the reader jumped to.
 */
export function JumpMenu({ label, children }: { label: string; children: React.ReactNode }) {
  const ref = useRef<HTMLDetailsElement>(null);
  return (
    <details
      ref={ref}
      className="group mb-8 rounded-lg border border-[#2a475e] bg-[#16202d] lg:hidden"
      onClick={(e) => {
        if (ref.current && e.target instanceof Element && e.target.closest("a[href^='#']")) ref.current.open = false;
      }}
    >
      <summary className="flex cursor-pointer select-none list-none items-center justify-between px-4 py-3 text-sm font-semibold text-[#e8eef3] [&::-webkit-details-marker]:hidden">
        {label}
        <ChevronDown className="h-4 w-4 text-[#8f98a0] transition-transform group-open:rotate-180" aria-hidden />
      </summary>
      <div className="max-h-[60vh] overflow-y-auto border-t border-[#2a475e]/70 px-2 py-3">{children}</div>
    </details>
  );
}
